import TYPES from '@/modules/shared/types';

// Domain
import { SupportTicketRepository } from '@/modules/zendesk/support-ticket/domain/repositories/support-ticket-repository';
import { SupportTicketDto } from '@/modules/zendesk/support-ticket/domain/dtos/support-ticket-dto';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class SupportTicketHttpRepository implements SupportTicketRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/dashboard/zendesk/support-ticket/`;

  create(support_ticket_dto: SupportTicketDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint, 'POST', support_ticket_dto)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
